export default {
      id: "qr-code-usage",
      viewBox: "0 0 232 232",
      url: __webpack_public_path__ + "img/icons.68fd9e19.svg#qr-code",
      toString: function () {
        return this.url;
      }
    }